exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".blog .blog-item {\n    border-bottom: 1px solid #eeeeee;\n    margin-bottom: 40px;\n    padding-bottom: 40px;\n  }\n  .blog .blog-item .item-image {\n    margin-top: 7px;\n    margin-right: 0;\n  }\n  .blog .blog-item .item-image.pull-left {\n    max-width: 100%;\n  }\n  .blog .blog-item .item-image img {\n    max-width: 100%;\n    width: 100%;\n  }\n  .blog .blog-item .page-header {\n    border: 0;\n    margin: 0 0 10px;\n    padding: 0;\n  }\n  .blog .blog-item .page-header h2 {\n    margin: 0;\n    line-height: 1.3;\n  }\n  .blog .blog-item .page-header h2 a:hover,\n  .blog .blog-item .page-header h2 a:focus,\n  .blog .blog-item .page-header h2 a:active {\n    color: #2a5269;\n  }\n  .blog .blog-item .article-intro {\n    margin-bottom: 20px;\n  }\n  .blog .item-page .tags {\n    border-bottom: 1px solid #eeeeee;\n    margin-bottom: 20px;\n  }\n  .blog .item-page .tags span a {\n    background: #eeeeee;\n  }", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./client/assets/css/blog.css
// module id = 284
// module chunks = 0